var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "word-search-character-wrapper" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(_setup.FontSelector, {
          staticClass: "col-12",
          attrs: { disabled: _setup.disabled },
          on: { input: _setup.onFontSelected },
          model: {
            value: _setup.model.font,
            callback: function ($$v) {
              _vm.$set(_setup.model, "font", $$v)
            },
            expression: "model.font",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 d-flex align-items-center" },
          [
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: {
                type: "decimal",
                step: ".01",
                min: 0,
                placeholder: "0.00",
                label: "Font size(pts)",
                disabled: _setup.disabled,
              },
              on: {
                input: function ($event) {
                  return _setup.updateFontSize(_setup.model.fontSize)
                },
              },
              model: {
                value: _setup.model.fontSize,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "fontSize", $$v)
                },
                expression: "model.fontSize",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }